import { atom, useAtom } from 'jotai';
import { useCallback, useMemo } from 'react';

export type RetailSaleStep = 'detail' | 'checkout' | 'invoicePreview';
const retailStepAtom = atom<RetailSaleStep>('detail');

export const useRetailSaleStep = () => {
  const [step, setStep] = useAtom(retailStepAtom);
  const goToCheckout = useCallback(() => setStep('checkout'), [setStep]);
  const goToDetail = useCallback(() => setStep('detail'), [setStep]);
  const goToInvoicePreview = useCallback(
    () => setStep('invoicePreview'),
    [setStep]
  );
  const resetStep = useCallback(() => setStep('detail'), [setStep]);

  return useMemo(
    () => ({ step, goToCheckout, goToDetail, goToInvoicePreview, resetStep }),
    [step, goToCheckout, goToDetail, goToInvoicePreview, resetStep]
  );
};
